import { Button, FileButton, Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { TFunction } from 'i18next';
import { useState } from 'react';

type OpenImportTelepacModalParams = {
  onImport: (file: File) => void;
  t: TFunction;
};

export function openImportTelepacModal({
  onImport,
  t,
}: OpenImportTelepacModalParams) {
  const ImportTelepacModalBody = () => {
    const [file, setFile] = useState<File | null>(null);

    return (
      <Stack gap="sm">
        <Text size="sm" style={{ lineHeight: 1.6 }}>
          {t('contracts.import-telepac-confirm-body')}
        </Text>
        <FileButton accept=".xml" onChange={setFile}>
          {(props) => (
            <Button {...props} variant="light">
              {t('uploadYieldMapForm.selectFile')}
            </Button>
          )}
        </FileButton>
        {file ? (
          <Text size="sm" c="dimmed">
            {file.name}
          </Text>
        ) : null}
        <Button
          disabled={!file}
          onClick={() => {
            if (file) {
              onImport(file);
            }
          }}
        >
          {t('contracts.import-telepac')}
        </Button>
      </Stack>
    );
  };

  modals.open({
    title: t('contracts.import-telepac-confirm-title'),
    children: <ImportTelepacModalBody />,
  });
}
